require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-significance-of-allies.json") })
        }
      }, "path---blog-the-significance-of-allies");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-significance-of-allies!./.cache/json/blog-the-significance-of-allies.json
// module id = 1073
// module chunks = 231608221292675